"use client";

import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import animationData from '../assets/animations/loading.json';
import { LottieRefCurrentProps } from 'lottie-react';

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  &.fade-out {
    opacity: 0;
  }
`;

const LoadingAnimation = styled.div`
  width: 100px;
  height: 100px;
`;

// Dynamically import Lottie with ssr: false
const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false
});

interface LoadingOverlayProps {
  isLoading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleAnimationLoad = () => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(3);
    }
  };

  const handleAnimationComplete = () => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(5);
    }
  };

  if (!isLoading) return null;

  return (
    <OverlayContainer>
      <LoadingAnimation>
        {/* The dynamic import with ssr: false handles client-side rendering */}
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop={true}
          autoplay={true}
          initialSegment={[0, 62]} // Adjust segment if needed for your animation
          style={{ transform: 'scale(1.5)' }} // Adjust scale if needed
          onDOMLoaded={handleAnimationLoad}
          onComplete={handleAnimationComplete}
          onLoopComplete={handleAnimationComplete}
        />
      </LoadingAnimation>
    </OverlayContainer>
  );
};

export default LoadingOverlay;